/*
 * @Author: pengzhihui
 * @Description:
 * @Date: 2020-02-13 17:35:29
 * @LastEditTime: 2021-06-27 17:30:44
 */
import moment from 'moment';
import { Env, MicroAppConfig } from './interfaces';
import request from './utils/request';


/**
 * fetch applist in test/beta/production
 */
export async function getAppInfos(appId: number, env: Env, identifyKey?: string): Promise<{ data: MicroAppConfig[] }> {
    let res = {
        data: [],
    };
    let envStr = window.location.host;
    if (identifyKey) {
        envStr = identifyKey;
    }
    const paramsStr = envStr ? `?id=${appId}&env=${envStr}` : `?id=${appId}`;
    const reqHost =
        env === 'production' || env === 'beta'
            ? 'https://dapi.e.kuaishou.com/rest/dolly/app/info'
            : 'https://ad-frontend-dolly.test.gifshow.com/rest/dolly/app/info';
    res = await request({
        url: `${reqHost}${paramsStr}`,
        withCredentials: false,
    });
    return res;
}

/**
 * fetch applist from cdn
 */
export async function getAppInfosFromCdn(appId: number, env: Env): Promise<MicroAppConfig[]> {
    let res = [];
    const name =
        env === 'production'
            ? `dolly_cms-${appId}-${moment().format('YYYYMMDD')}`
            : `dolly_cms_test-${appId}-${moment().format('YYYYMMDD')}`;
    try {
        await request({
            url: `https://static.yximgs.com/udata/pkg/ad-dolly/${name}.json`,
            withCredentials: false,
        });
    } catch (e) {
        res = e;
    }
    return res;
}

/**
 * fetch appinfo when start in MicroApp, request appinfo to MicroApp
 */
export async function getDevAppInfos(appId: number): Promise<{ data: MicroAppConfig[] }> {
    const res = await request<{ data: MicroAppConfig[] }>({
        url: `http://localhost:${process.env.REACT_APP_MAIN_APP_PORT}/rest/dolly/app/info?id=${appId}`,
        withCredentials: false,
    });
    return res;
}
